import { useAuth } from '@/context/AuthContext';
import { AlertTriangle, X } from 'lucide-react';
import { useState, useEffect } from 'react';
import { toast } from 'sonner';

export default function DemoBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  // Intercept fetch responses for demo mode toasts
  useEffect(() => {
    if (!user?.is_demo) return;
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      // Clone the response to read it without consuming
      const clone = response.clone();
      try {
        const data = await clone.json();
        if (data?.demo === true && data?.message) {
          toast.info(data.message, { duration: 2500 });
        }
      } catch { /* not JSON or other error */ }
      return response;
    };
    return () => { window.fetch = originalFetch; };
  }, [user?.is_demo]);

  if (!user?.is_demo || dismissed) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-2 text-sm font-medium shadow-lg"
      data-testid="demo-banner"
    >
      <AlertTriangle className="w-4 h-4 flex-shrink-0" />
      <span>Demo data — for demonstration only</span>
      <button
        onClick={() => setDismissed(true)}
        className="ml-4 p-0.5 hover:bg-amber-600 rounded transition-colors"
        data-testid="demo-banner-dismiss"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
